// import Vue from 'vue'
// import Vuex from 'vuex'

// Vue.use(Vuex)

// export default new Vuex.Store({
//   state: {
//     cartList: []
//   },
//   mutations: {
//     addToCart (state, goods) {
//       const index = state.cartList.findIndex(item => item.id === goods.id)
//       if (index === -1) {
//         state.cartList.push({
//           id: goods.id,
//           productName: goods.productName,
//           price: goods.price,
//           count: 1
//         })
//       } else {
//         state.cartList[index].count++
//       }
//     },
//     removeFromCart (state, id) {
//       const index = state.cartList.findIndex(item => item.id === id)
//       if (index !== -1) {
//         state.cartList.splice(index, 1)
//       }
//     }
//   },
//   actions: {
//     addToCart ({ commit }, goods) {
//       commit('addToCart', goods)
//     },
//     removeFromCart ({ commit }, id) {
//       commit('removeFromCart', id)
//     }
//   },
//   getters: {
//     cartList: state => state.cartList,
//     cartTotal: state => state.cartList.reduce((total, item) => total + item.count, 0),
//     cartAmount: state => state.cartList.reduce((total, item) => total + item.price * item.count, 0)
//   }
// })

// import Vue from 'vue'
// import Vuex from 'vuex'
// // 1. 导入购物车的 vuex 模块
// import moduleCart from './cart.js'
 
// Vue.use(Vuex)
 
// const store = new Vuex.Store({
//   // TODO：挂载 store 模块
//   modules: {
//     // 2. 挂载购物车的 vuex 模块，模块内成员的访问路径被调整为 m_cart，例如：
//     //    购物车模块中 cart 数组的访问路径是 m_cart/cart
//     m_cart: moduleCart,
//   },
// })
 
// export default store


import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);


let state = {
    cartCount:0,
    resetFlag:true,

    scrollPosition: 0, // 列表页滚动位置
    currentPage: 1, // 当前页码
    shareSource: false, // 是否从分享页面进入
    releaseType: null, // 我发布的类型

    // 认证相关状态
    isAuthenticated: false, // 是否已认证
    userInfo: null, // 用户信息
    accessToken: null, // 访问令牌
    refreshToken: null, // 刷新令牌
    tokenExpiry: null, // token过期时间
    accountType: null, // 账号类型
    isRefreshingToken: false, // 是否正在刷新token
}


// let actions = {
//     handleActions({}){
//         alert(1);
//     }
// }



let mutations = {
    handleMutationsFlag(state,newVal){
        state.resetFlag=newVal;
    },
    handleMutationsAdd(state,newVal){
        state.cartCount=state.cartCount+Number(newVal);
        window.sessionStorage.setItem('cartCountXpz', JSON.stringify(state.cartCount));
    },
    handleMutationsDel(state,newVal){
        state.cartCount=state.cartCount-Number(newVal);
        window.sessionStorage.setItem('cartCountXpz', JSON.stringify(state.cartCount));
    },

      // 更新滚动位置
      updateScrollPosition(state, position) {
        state.scrollPosition = position;
      },
       // 更新当前页码
    updateCurrentPage(state, page) {
        state.currentPage = page;
      },
    setShareSource(state, value) {
      state.shareSource = value;
    },
    setReleaseType(state, type) {
      state.releaseType = type;
    },

    // 认证相关mutations
    SET_AUTHENTICATED(state, isAuthenticated) {
      state.isAuthenticated = isAuthenticated;
    },
    SET_USER_INFO(state, userInfo) {
      state.userInfo = userInfo;
    },
    SET_ACCESS_TOKEN(state, token) {
      state.accessToken = token;
    },
    SET_REFRESH_TOKEN(state, token) {
      state.refreshToken = token;
    },
    SET_TOKEN_EXPIRY(state, expiry) {
      state.tokenExpiry = expiry;
    },
    SET_ACCOUNT_TYPE(state, type) {
      state.accountType = type;
    },
    SET_REFRESHING_TOKEN(state, isRefreshing) {
      state.isRefreshingToken = isRefreshing;
    },
    CLEAR_AUTH(state) {
      state.isAuthenticated = false;
      state.userInfo = null;
      state.accessToken = null;
      state.refreshToken = null;
      state.tokenExpiry = null;
      state.accountType = null;
      state.isRefreshingToken = false;
    },
  
}


let actions = {
    // 认证相关actions
    loginSuccess({ commit }, { userInfo, accessToken, refreshToken, accountType }) {
      commit('SET_AUTHENTICATED', true);
      commit('SET_USER_INFO', userInfo);
      commit('SET_ACCESS_TOKEN', accessToken);
      commit('SET_REFRESH_TOKEN', refreshToken);
      commit('SET_ACCOUNT_TYPE', accountType);

      // 计算token过期时间（假设token有效期为2小时）
      const expiry = Date.now() + (2 * 60 * 60 * 1000);
      commit('SET_TOKEN_EXPIRY', expiry);

      // 持久化存储认证信息
      const authData = {
        userInfo,
        accessToken,
        refreshToken,
        accountType,
        tokenExpiry: expiry
      };
      localStorage.setItem('xpzAuthData', JSON.stringify(authData));
    },

    logout({ commit }) {
      commit('CLEAR_AUTH');
      // 清除本地存储的认证信息
      localStorage.removeItem('xpzAuthData');
      sessionStorage.removeItem('userInfoXpz');
      sessionStorage.removeItem('accountTypeXpz');
    },

    refreshToken({ commit, state }, newTokenData) {
      commit('SET_ACCESS_TOKEN', newTokenData.accessToken);
      if (newTokenData.refreshToken) {
        commit('SET_REFRESH_TOKEN', newTokenData.refreshToken);
      }

      // 更新过期时间
      const expiry = Date.now() + (2 * 60 * 60 * 1000);
      commit('SET_TOKEN_EXPIRY', expiry);

      // 更新本地存储
      const authData = {
        userInfo: state.userInfo,
        accessToken: newTokenData.accessToken,
        refreshToken: newTokenData.refreshToken || state.refreshToken,
        accountType: state.accountType,
        tokenExpiry: expiry
      };
      localStorage.setItem('xpzAuthData', JSON.stringify(authData));
    },

    loadAuthFromStorage({ commit }) {
      try {
        const authDataStr = localStorage.getItem('xpzAuthData');
        console.log('[Store] loadAuthFromStorage - raw xpzAuthData:', authDataStr);
        if (authDataStr) {
          const authData = JSON.parse(authDataStr);
          console.log('[Store] loadAuthFromStorage - parsed authData:', authData);

          // 检查token是否过期
          if (authData.tokenExpiry && authData.tokenExpiry > Date.now()) {
            commit('SET_AUTHENTICATED', true);
            commit('SET_USER_INFO', authData.userInfo);
            commit('SET_ACCESS_TOKEN', authData.accessToken);
            commit('SET_REFRESH_TOKEN', authData.refreshToken);
            commit('SET_ACCOUNT_TYPE', authData.accountType);
            commit('SET_TOKEN_EXPIRY', authData.tokenExpiry);
            console.log('[Store] loadAuthFromStorage - success, accountType:', authData.accountType);
            return true;
          } else {
            console.log('[Store] loadAuthFromStorage - token expired or invalid, removing xpzAuthData');
            // token已过期，清除存储
            localStorage.removeItem('xpzAuthData');
          }
        } else {
          console.log('[Store] loadAuthFromStorage - no xpzAuthData found');
        }
      } catch (error) {
        console.error('[Store] loadAuthFromStorage - error parsing xpzAuthData:', error);
        localStorage.removeItem('xpzAuthData');
      }
      return false;
    },

    setRefreshingToken({ commit }, isRefreshing) {
      commit('SET_REFRESHING_TOKEN', isRefreshing);
    }
}

let getters = {
  cartCount(state){
        return state.cartCount
    },
    // 认证相关getters
    isAuthenticated: state => state.isAuthenticated,
    userInfo: state => state.userInfo,
    accessToken: state => state.accessToken,
    refreshToken: state => state.refreshToken,
    tokenExpiry: state => state.tokenExpiry,
    accountType: state => state.accountType,
    isRefreshingToken: state => state.isRefreshingToken,
    isTokenExpired: state => {
      if (!state.tokenExpiry) return true;
      return Date.now() >= state.tokenExpiry;
    }
}


// vuex配置项  公共的内存空间
const store = new Vuex.Store({
    state,
    actions,
    mutations,
    getters
})


export default store;